import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/outsourced/payroll/reports/page.tsx");
